import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xkgtz9fzxt: FaireBrandEntity = {
  token: "b_xkgtz9fzxt",
  type: "brand",
  name: "body restore⎜steam eye masks, shower steamers, tallow",
  avatarUrl:
    "https://cdn.faire.com/fastly/03cd855983dfc0780143a1d2a7a4f6a865f18c1586963f80f35adb22f15d108a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/201885578076f82be11ec2c5c849d2ad069374615714fbbf51a34ef02ab38d2f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/03cd855983dfc0780143a1d2a7a4f6a865f18c1586963f80f35adb22f15d108a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/201885578076f82be11ec2c5c849d2ad069374615714fbbf51a34ef02ab38d2f.png",
  location: "Sacramento, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "Body Restore ⎜ The Global Leader in Aromatherapy & Ancestral Skincare\n\nBody Restore is the world’s #1 Made in the USA shower steamer brand, trusted by over 10 million customers with $100M+ in lifetime sales. Founded to bridge the gap between luxury spa experiences and everyday wellness, we create high-performance self-care rituals using pure essential oils and clean, non-toxic ingredients.\n\nOriginally recognized for our therapeutic shower steamers, we have evolved into a comprehensive wellness collective. Our curated catalog now features high-growth categories including:\n\n•Aromatherapy & Sleep: Air-activated, self-heating steam eye masks.\n\n•Ancestral Skincare: Grass-fed beef tallow balms infused with Manuka honey.\n\n•K-Beauty Innovation: Advanced 7x Hyaluronic Acid cooling toner pads.\n\n•Natural Bath & Body: Probiotic-rich goat milk soaps.\n\nEvery Body Restore product is designed with eco-friendly, gift-ready packaging, making it the perfect addition to boutique gift shops, spas, and lifestyle retailers. Whether your customers are seeking relief from stress, better sleep, or clean skincare solutions, Body Restore delivers indulgent, spa-grade experiences that are accessible, natural, and effective.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:07.155Z",
    importedBy: "entity-db-cli",
  },
};
